<template>
  <span>
    <ul class="langSelect">
      <li v-for="item in listLang" :key="item" @click="onClick(item)">
        <p
          class="langSelect-color text-md uppercase"
          v-bind:class="{ activeLangSelectItem: item === currentLang }"
        >
          {{ item }}
        </p>
      </li>
    </ul>
    <div
      class="mobilelangSelectItem text-md uppercase"
      v-bind:class="{ openMobileLangList: selectToggler }"
      @click="toggleSelect"
    >
      <p>
        {{ currentLang }}
      </p>
    </div>
    <ul v-if="selectToggler" class="mobilelangSelect">
      <li
        v-for="item in listLang"
        :key="item"
        @click="onClickMobile(item)"
        v-bind:class="{ disableLangSelectItem: item === currentLang }"
      >
        <p class="langSelect-color text-md uppercase">
          {{ item }}
        </p>
      </li>
    </ul>
  </span>
</template>

<script>
import langBD from '@/assets/dictionary/index'
import { mapState } from 'vuex'
import { newList } from '@/store/modules/advantages'
import { newClients } from '@/store/modules/clients'
import { newTabs } from '@/store/modules/forms'
import { newExplonations } from '@/store/modules/how'
import { newMessages } from '@/store/modules/main'
import { newLinks } from '@/store/modules/navigation'
import { newPartners } from '@/store/modules/partners'
import { newPositionList } from '@/store/modules/positions'
import { newAddress } from '@/store/modules/proprietary'

export default {
  name: 'LangSelect',
  data: () => {
    return {
      selectToggler: false,
    }
  },
  computed: {
    ...mapState('navigation', ['links'], 'currentLang'),
    currentLang() {
      return this.$store.state.main.currentLang
    },
    listLang() {
      return Object.keys(langBD)
    },
  },
  methods: {
    onClick: function(val) {
      this.updateValues(val)
      this.$store.commit('changeLang', val)
      this.$store.commit('changeDic', langBD[val])
    },
    toggleSelect: function() {
      return (this.selectToggler = !this.selectToggler)
    },
    onClickMobile: function(val) {
      this.selectToggler = !this.selectToggler
      this.updateValues(val)
      this.$store.commit('changeLang', val)
      this.$store.commit('changeDic', langBD[val])
    },
    updateValues(lang) {
      const {
        sectionMain,
        forms,
        howItWorks,
        nav,
        partners,
        sectionPositions,
        sectionAdvantages: { lists, transporter, shipper },
        clientsSection: { list },
        footer: { address },
      } = langBD[lang]

      this.$store.commit('changeMainMassage', newMessages(sectionMain))
      this.$store.commit(
        'changeAdvantagesData',
        newList(lists, transporter, shipper)
      )
      this.$store.commit('changeClients', newClients(list))
      this.$store.commit('changeFormsTabs', newTabs(forms))
      this.$store.commit('changeHowExplonation', newExplonations(howItWorks))
      this.$store.commit('changeNavigationLinks', newLinks(nav))
      this.$store.commit('changePartners', newPartners(partners))
      this.$store.commit(
        'changePositionList',
        newPositionList(sectionPositions)
      )
      this.$store.commit('changeProprietaryAddress', newAddress(address))
    },
  },
}
</script>

<style lang="scss" scoped>
.langSelect {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > li {
    padding: 0 10px;
    border-right: 1px solid black;
    cursor: pointer;
  }
  & > li:last-child {
    border-right: none;
  }
}
.langSelect-color {
  color: #021759;
}
.activeLangSelectItem {
  color: #0067d6;
}
.mobilelangSelect {
  display: none;
}
.mobilelangSelectItem {
  display: none;
}
</style>

<style lang="scss" scoped>
@media (max-width: 984px) {
  .langSelect {
    display: none;
  }
  .disableLangSelectItem {
    display: none;
  }
  .mobilelangSelectItem {
    display: block;
    margin-top: 31px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 5px;
    & > p {
      padding-bottom: 10px;
      border-bottom: 1px solid black;
      color: #0067d6;
    }
  }
  .openMobileLangList {
    border-bottom: none;
    background-color: white;
  }
  .mobilelangSelect {
    /* margin-top: 3px; */
    z-index: 1000;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: white;

    & > li {
      padding: 10px 0;
      border-right: none;
      border-bottom: 1px solid black;
      cursor: pointer;
    }
    & > li:last-child {
      border-bottom: none;
    }
  }
}
</style>
